import { env } from './env';

const getAppEnv = (shouldIncludeDots: boolean): string => {
  const ctctEnv = env('NEXT_PUBLIC_URL_CTCT_ENV');
  const appEnv = shouldIncludeDots ? formatEnvWithDots(ctctEnv) : formatEnvWithoutDots(ctctEnv);
  return appEnv;
};

const formatEnvWithDots = (ctctEnv: string | undefined): string => {
  return ['l1', 's1'].includes(ctctEnv ?? '') ? `.${ctctEnv}.` : '.';
};

const formatEnvWithoutDots = (ctctEnv: string | undefined): string => {
  return ctctEnv && ['l1', 's1'].includes(ctctEnv ?? '') ? ctctEnv : '';
};

const appEnv = getAppEnv(true);
export { appEnv, getAppEnv };
